{{'VEHICLE'|translate}} <strong>{{notification.vehicleName}}</strong><span translate> NOTIFICATION_ZONE.{{notification.state|uppercase}} </span>
<strong>{{notification.zoneName}}</strong>
